module.exports = __webpack_public_path__ + "static/media/SourceSansPro-Semibold.cb0d542e.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/SourceSansPro-Semibold.woff
// module id = 341
// module chunks = 3